<template lang="pug">
y-dialog(v-model="dialogOpen" width="290px" persistent)
  v-date-picker.elevation-2(v-model="dates" range no-title)
    v-spacer
    v-btn(color="white" text @click="dialogOpen = false")
      .button-Aa-small.primary400--text {{ $t('cancel') }}
    v-btn.mr-2(color="textColorAccent" depressed height=32 @click="ok" :disabled="dates.length < 2")
      .button-AA-small.basic100--text OK
</template>

<script>
export default {
  name: "DateRangePickerDialog",
  props: ['dialog'],
  data: (vm) => ({
    dialogOpen: vm.dialog,
    dates: []
  }),
  watch: {
    dialog (val) {
      this.dialogOpen = val
    },
    dialogOpen(val) {
      // console.log('emit')
      this.$emit('update:dialog', val)
    }
  },
  methods: {
    ok () {
      this.dialogOpen = false
      this.$emit('selected', this.dates)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>